/**
 * blurOnEscape.js — kill the stray focus ring that appears on a button after
 * Escape.
 *
 * The mechanism: clicking a button with the MOUSE leaves it focused but not
 * :focus-visible, so nothing is drawn. Pressing Escape is a keyboard event, which
 * flips the browser's heuristic to "this user is on the keyboard" and re-evaluates
 * :focus-visible on the still-focused button — the ring appears out of nowhere.
 * Most visible on the drawing tools: pick a tool, press Escape to cancel, get a
 * ring around the tool button.
 *
 * The fix is to drop focus, NOT to delete the :focus-visible rule. Keyboard users
 * need that ring to see where they are; only the leftover mouse focus is unwanted.
 *
 * Tab-focus is untouched: a keyboard-focused button is :focus-visible already, and
 * Escape there means "leave this control" anyway.
 */
export function installBlurOnEscape() {
  if (typeof window === 'undefined' || window.__blurOnEscInstalled) return;
  window.__blurOnEscInstalled = true;

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const el = document.activeElement;
    if (!el || el === document.body) return;
    // Never yank focus out of something the user is typing into — Escape there is
    // the field's own business (clear/close), not ours.
    const tag = el.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable) return;
    if (typeof el.blur === 'function') el.blur();
  }, true);
}
